import * as React from 'react';
import { ConfirmProps } from '../Provider';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  createTheme,
  ThemeProvider,
} from '@mui/material';
import { useAppSelector } from '../../../hooks';
import { selectTheme } from '../../../slices/global/themeSlice';

const AlertDialog = (props: ConfirmProps) => {
  const { open, title, message, acceptText, rejectText, proceed, reject } = props;
  const mode = useAppSelector(selectTheme);

  const darkTheme = createTheme({
    palette: {
      mode: mode,
    },
  });

  return (
    <ThemeProvider theme={darkTheme}>
      <Dialog
        open={open}
        onClose={(_, reason: string) => {
          if (reason === 'backdropClick' || !reject) return;
          reject();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <div dangerouslySetInnerHTML={{ __html: title }} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (reject) reject();
            }}
          >
            {rejectText}
          </Button>
          <Button
            autoFocus
            onClick={() => {
              if (proceed) proceed();
            }}
          >
            {acceptText}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default AlertDialog;
